import styled from 'styled-components';
import { VISUALLY_HIDDEN } from '@optimus-web/common';

export const VisuallyHidden = styled.span`
    ${VISUALLY_HIDDEN};
`;
